module.exports = __webpack_public_path__ + "img/Marley_Logo.24ade951.png";